<template>
  <div class="footer">
    <div class="footer-top">
      <router-link to="/index">首页</router-link>
      <div class="right">
        <el-input placeholder="请输入关键词" prefix-icon="el-icon-search" v-model="keyWords" clearable @keyup.enter="handleSearch" @clear="handleSearch" />
        <el-button icon="el-icon-search" circle @click="handleSearch"></el-button>
      </div>
    </div>
    <div class="center">
      <div class="left">
        <div>
          <router-link v-for="(item, index) in leftTop"
                       :to="item.url"
                       :key="index"
                       @click.native="item.type === 'dialog' ? showEquipmentPurchase() : null">
            {{ item.label }}
          </router-link>
        </div>
        <div class="concat">
          <router-link v-for="(item, index) in leftConcat" :to="item.url" :key="index">
            {{ item.label }}
          </router-link>
        </div>
      </div>
      <div class="right">
        <div class="call">
          <div style="display: flex; align-items: center">
            <i class="el-icon-phone-outline"></i>
            <span class="hotline">服务热线：</span>
          </div>
          <div class="phone">
            <p>0817-2269292</p>
            <p>400-677-2204</p>
          </div>
        </div>
        <div class="call">
          <div style="display: flex; align-items: center">
            <i class="el-icon-time"></i>
            <span class="hotline">服务时间：</span>
          </div>
          <div class="phone">
            <p>冬周一到周五9:00~18:30</p>
            <p>夏周一到周五9:00~18:30</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="toplink">
        <div v-for="(item, index) in footerBottm" :key="index" style="display: flex; flex-direction: column; align-items: center" class="icons">
          <img :src="item.icon" alt="" />
          <el-link :underline="false" :href="item.url" target="_blank">{{ item.label }}</el-link>
        </div>
      </div>
      <div class="beian">
        {{ config.copyright }}
        <a data-v-374f9f61="" href="https://beian.miit.gov.cn" target="_blank" title="工信部备案管理系统">{{ config.icp }}</a>
        <a data-v-374f9f61="" target="_blank" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${config.ga}`">
          <img data-v-374f9f61="" src="~@/assets/beian.ga.png" />
          {{ config.ga }}
        </a>
        <span data-v-374f9f61="">川网文 {{ config.network }}</span>
      </div>
    </div>

    <el-dialog
      top="5vh"
      :visible.sync="equipmentDialogVisible"
      width="500px"
      custom-class="equipment-purchase-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div slot="title" class="equipment-dialog-header">
        <div class="equipment-dialog-title-left">
          <span style="font-size: 24px; font-weight: bold; color: #fff;">
            设备采购中心
          </span>
        </div>
        <div class="equipment-dialog-title-right" @click="equipmentDialogVisible = false">
          <div class="close-btn">
            <img src="@/assets/images/close.png" alt="close">
          </div>
        </div>
      </div>

      <div class="equipment-dialog-content">
        <div class="equipment-intro-section">
          <div class="intro-header">
            <div class="intro-icon">
              <i class="el-icon-shopping-cart-2"></i>
            </div>
            <div class="intro-text">
              <h3>专业设备采购</h3>
              <p>一站式采购解决方案，品质保障，售后无忧</p>
            </div>
          </div>

          <div class="equipment-features">
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>质量保障</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>专业技术支持</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>快速物流配送</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>售后无忧</span>
            </div>
          </div>
        </div>

        <div class="qrcode-section">
          <div class="qrcode-header">
            <div class="qrcode-title-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <div class="qrcode-title-text">
              <h4>前往小程序采购</h4>
              <p>使用微信扫一扫，查看设备详情并下单</p>
            </div>
          </div>

          <div class="qrcode-container">
            <div class="qrcode-wrapper">
              <div class="qrcode-image-container">
                <img
                  src="@/assets/images/small_app_code.jpg"
                  alt="小程序码"
                  class="qrcode-image"
                  v-if="qrcodeImageLoaded"
                  @error="handleImageError"
                />
                <div v-else class="qrcode-placeholder">
                  <div class="placeholder-icon">
                    <i class="el-icon-picture"></i>
                  </div>
                  <p>采购二维码</p>
                </div>
              </div>

              <div class="qrcode-tips">
                <div class="tip-item">
                  <i class="el-icon-search"></i>
                  <span>扫码查看设备</span>
                </div>
                <div class="tip-item">
                  <i class="el-icon-shopping-cart-2"></i>
                  <span>在线选购专业设备</span>
                </div>
                <div class="tip-item">
                  <i class="el-icon-chat-line-round"></i>
                  <span>专业客服一对一咨询</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="equipment-dialog-footer">
        <el-button
          class="cancel-btn"
          @click="equipmentDialogVisible = false"
        >
          稍后查看
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils";
import { friendlyLinkApi } from "@/api/home";
import { getSecurityFilingApi } from "@/api";
import { mapGetters } from "vuex";

export default {
  name: "PcShoppingFooter",

  data() {
    return {
      footerValue: "",
      leftTop: [
        {
          label: "关于我们",
          url: "/other/about-us"
        },
        {
          label: "设备采购",
          url: "#",
          type: "dialog"
        },
        {
          label: "通知公告",
          url: "/notice"
        },
      ],
      leftConcat: [
        { label: "API接口", url: "/" },
        { label: "帮助中心", url: "/help/index" },
        { label: "投诉建议", url: "/other/complaints" },
      ],
      friendshipLink: [],
      footerBottm: [
        {
          label: "全国12315互联网平台",
          url: "",
          icon: "https://yikerenyang.oss-cn-beijing.aliyuncs.com/tcv35xo18hlv9ookn8hf.png",
        },
        {
          label: "互联网不良与违法信息举报",
          url: "",
          icon: "https://yikerenyang.oss-cn-beijing.aliyuncs.com/p2btlgjs3je4ehc17iht.png",
        },
        {
          label: "网络举报APP下载",
          url: "",
          icon: "https://yikerenyang.oss-cn-beijing.aliyuncs.com/a5mw1dnq8m3dn0pd66gb.png",
        },
      ],
      keyWords: "",
      urlBase: utils.getUrlBase(),
      copyright: "",
      equipmentDialogVisible: false,
      qrcodeImageLoaded: true,
    };
  },
  computed: {
    ...mapGetters(["config"]),
  },
  mounted() {
    this.getFriendlyLinkApi();
    this.loadGetSecurityFilingApi();
  },

  methods: {
    handleSearch() {
      const keyWords = this.keyWords.trim()
      if (!keyWords) {
        this.$message.warning('请输入搜索关键词')
        return
      }

      this.$router.push({
        path: '/search/index',
        query: { keyWords: keyWords }
      })
    },

    getFriendlyLinkApi() {
      friendlyLinkApi().then((res) => {
        this.friendshipLink = res.data ? JSON.parse(res.data) : [];
      });
    },

    loadGetSecurityFilingApi() {
      getSecurityFilingApi().then((res) => {
        this.copyright = res.data.replace(/<[^>]*>/g, "");
      });
    },

    showEquipmentPurchase() {
      this.equipmentDialogVisible = true;
      this.qrcodeImageLoaded = true;
    },

    handleImageError() {
      this.qrcodeImageLoaded = false;
      console.warn('设备采购二维码图片加载失败');
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  font-size: 12px;

  .footer-top {
    height: 80px;
    padding: 0 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 2px solid #f7f7f7;
    border-bottom: 2px solid #f7f7f7;
    box-sizing: border-box;

    a {
      color: #3d3d3d !important;
      font-size: 14px;
      margin-right: 30px;

      &:hover {
        color: #4CAF4F !important;
      }
    }

    .el-input {
      width: 260px;
      margin-right: 15px;
    }
  }

  .center {
    width: 100%;
    padding: 30px 60px 30px 60px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .left {
      min-width: 0;
      flex: 1;

      a {
        margin-right: 40px;
        font-size: 12px !important;
        cursor: pointer;

        &:hover {
          color: #4CAF4F !important;
        }

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }

      .concat {
        margin-top: 20px;
        margin-bottom: 20px;

        a {
          margin-right: 0;
          padding: 0 15px;
          border-right: 2px solid #333;

          &:nth-child(1) {
            padding-left: 0;
          }

          &:nth-last-child(1) {
            padding-right: 0;
            border-right: none;
          }
        }
      }

      .friendshipLink {
        display: flex;
        align-items: center;
        span {
          font-size: 12px;
        }

        a {
          margin-right: 10px;
        }
      }
    }

    .right {
      min-width: 0;
      flex: 1;
      display: flex;

      .call {
        color: #999;
        margin-right: 100px;

        &:nth-last-child(1) {
          margin: 0;
        }

        .el-icon-phone-outline,
        .el-icon-time {
          font-size: 20px;
        }

        .hotline {
          margin-left: 5px;
        }
      }

      .phone {
        font-size: 16px;
        color: #3d3d3d;
      }
    }
  }

  .bottom {
    width: 100%;
    padding: 30px 60px;
    background-color: #50af6e;
    box-sizing: border-box;

    .toplink {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;

      .icons {
        margin-right: 80px;
        .el-link {
          color: #fff;
          font-size: 12px;
        }
        img {
          width: 30px;
          height: 30px;
          margin-bottom: 10px;
        }

        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }

    .beian {
      text-align: center;
      color: #fff;
      a {
        color: #fff;
        margin-left: 10px;
        margin-right: 10px;
        img {
          width: 14px;
        }
      }
    }
  }
}

.equipment-purchase-dialog {
  border-radius: 16px;
  overflow: hidden;

  .el-dialog__header {
    padding: 0;
    margin-bottom: 0;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 0;
  }

  .equipment-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 24px 16px;
    background: linear-gradient(135deg, #4CAF4F 0%, #5BCB20 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .equipment-dialog-title-left {
      color: white;
      font-size: 18px;
      font-weight: 600;

      span {
        color: white;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }

    .equipment-dialog-title-right {
      cursor: pointer;

      .close-btn {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color 0.3s;

        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        img {
          width: 20px;
          height: 20px;
          filter: brightness(0) invert(1);
        }
      }
    }
  }

  .equipment-dialog-content {
    .equipment-intro-section {
      padding: 20px 24px;
      background: linear-gradient(135deg, #f8fff8 0%, #f0f9f0 100%);
      border-bottom: 1px solid #e8f5e8;

      .intro-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 20px;

        .intro-icon {
          width: 48px;
          height: 48px;
          background: linear-gradient(135deg, #4CAF4F, #5BCB20);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 24px;
            color: white;
          }
        }

        .intro-text {
          h3 {
            margin: 0 0 6px 0;
            font-size: 18px;
            font-weight: bold;
            color: #333;
          }

          p {
            margin: 0;
            font-size: 14px;
            color: #666;
          }
        }
      }

      .equipment-features {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;

        .feature-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #4CAF4F;
          background: rgba(76, 175, 79, 0.1);
          padding: 8px 12px;
          border-radius: 8px;

          i {
            font-weight: bold;
          }

          span {
            color: #333;
          }
        }
      }
    }

    .qrcode-section {
      padding: 24px 24px 5px;

      .qrcode-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;

        .qrcode-title-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #4CAF4F 0%, #5BCB20 100%);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            color: white;
            font-size: 20px;
          }
        }

        .qrcode-title-text {
          h4 {
            margin: 0 0 4px 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }

          p {
            margin: 0;
            font-size: 14px;
            color: #666;
          }
        }
      }

      .qrcode-container {
        .qrcode-wrapper {
          background: white;
          border: 1px solid #e8f5e8;
          border-radius: 12px;
          padding: 20px 20px 10px;
          text-align: center;

          .qrcode-image-container {
            margin: 0 auto 20px;
            width: 180px;
            height: 180px;
            background: #f9f9f9;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            .qrcode-image {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .qrcode-placeholder {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: #f8fafc;

              .placeholder-icon {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, #4CAF4F 0%, #5BCB20 100%);
                border-radius: 50%;
                margin-bottom: 12px;

                i {
                  font-size: 30px;
                  color: white;
                }
              }

              p {
                color: #4CAF4F;
                font-size: 14px;
                margin: 0;
                font-weight: 500;
              }
            }
          }

          .qrcode-tips {
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-bottom: 10px;

            .tip-item {
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              color: #666;
              font-size: 14px;
              padding: 8px;
              background: #f8fafc;
              border-radius: 8px;

              i {
                color: #4CAF4F;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }

  .equipment-dialog-footer {
    display: flex;
    justify-content: space-between;
    padding: 20px 24px;
    border-top: 1px solid #e8e8e8;

    .cancel-btn,
    .consult-btn {
      flex: 1;
      height: 45px;
      font-size: 16px;
      border-radius: 8px;
      margin: 0 10px;
    }

    .cancel-btn {
      border: 1px solid #dcdfe6;
      color: #606266;

      &:hover {
        border-color: #4CAF4F;
        color: #4CAF4F;
      }
    }
  }
}
</style>

<style lang="scss">
.equipment-purchase-dialog {
  border-radius: 16px !important;

  .el-dialog__header {
    padding: 0 !important;
  }

  .el-dialog__body {
    padding: 0 !important;
    max-height: 70vh;
    overflow-y: auto;
  }

  .el-dialog__footer {
    padding: 0 !important;
  }
}

.equipment-purchase-dialog .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.equipment-purchase-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.equipment-purchase-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.equipment-purchase-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
